import api from "../api/axios";

  

const FeedBackService = {
 
    sendFeedback : async (params) => {
        const res = await api.post("/UserFeedback/create",  params );
        return res.data.data || res.data;
    }, 
 
};

export default FeedBackService;